module.exports = __webpack_public_path__ + "img/httpcreatedevice.be00962e.png";